module.exports = __webpack_public_path__ + "static/logo-290fba956f6f73c82cc56bc81bf4d424.png";